import { inject, Injectable } from '@angular/core';
import { Observable, map, of } from 'rxjs';
import { IResponse, IUserEventsWrapper, IUserModel } from '../models';
import { DataStorageService } from './storage';
import { BaseService } from '@shared/core';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private storageService = inject(DataStorageService);
  private baseService = inject(BaseService);

  get userInfo(): IUserModel | undefined {
    return this.storageService.getUserData<IUserModel>();
  }

  get userInfo$(): Observable<IUserModel | null> {
    return this.storageService.onUserDataChanged();
  }

  getCurrentUser(): Observable<IUserModel> {
    if (this.userInfo) {
      return of(this.userInfo);
    }
    return this.baseService.get<IResponse<IUserModel>>('auth/current-user').pipe(
      map(response => {
        this.storageService.setUserData(response.value);
        return response.value;
      }),
    );
  }

  getUserEvents(id: string): Observable<unknown> {
    return this.baseService.get<IResponse<IUserEventsWrapper>>(`users/${id}/events`).pipe();
  }

  clearUserInfo(): void {
    this.storageService.clearUserData();
  }

  logoutFromUser(): void {
    this.storageService.logout();
  }
}
